module.exports = __webpack_public_path__ + "static/media/warning-accent.36fee44f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning-accent.svg
// module id = 684
// module chunks = 0